export const buildProviderOptionDraft = (options: Record<string, unknown>): Record<string, string> =>
  Object.fromEntries(Object.entries(options).map(([option, value]) => [option, JSON.stringify(value) ?? 'null']));
